import { FONTSIZE } from "../../constants";
import useThemeHook from "../hooks/useThemeHook";
import { THEME_COLORS } from "../themes/DarkLight";
import Text from "./ThemedText";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

function CryptoListTileCard({
  crypto,
}: {
  crypto: any;
}) {
  const theme = useThemeHook();
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const goToCryptoViewPage = () => {
    navigate(`/crypto/${crypto.id}`);
  };

  const priceChangeColor =
    crypto?.price_change_percentage_24h > 0 ? "text-green-600" : "text-red-600";

  return (
    <div
      onClick={goToCryptoViewPage}
      className={`flex items-center justify-between w-full p-4 rounded-2xl mb-3 cursor-pointer bg-transparent ${
        isHovered ? "shadow-md" : ""
      } transition-shadow`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        borderColor: theme === "dark" ? THEME_COLORS.dark.less_theme : "gray-200",
      }}
    >
      <div className="flex items-center justify-start gap-3 flex-grow">
        <img
          loading="lazy"
          src={crypto["image"] || "/placeholder.svg"}
          alt={crypto?.name}
          className="w-12 h-12 rounded-full bg-gray-100 object-cover"
          style={{
            backgroundColor: theme === "dark" ? THEME_COLORS.dark.less_theme : "gray-100",
          }}
        />
        <div>
          <h4 className="text-base font-medium text-gray-900 mb-1" style={{ color: theme === "dark" ? THEME_COLORS.dark.inverse_theme : "gray-900" }}>
            {crypto?.name}
          </h4>
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-600" style={{ color: theme === "dark" ? THEME_COLORS.dark.inverse_theme : "gray-600" }}>
              ${crypto?.current_price}
            </span>
            <span className={`text-xs font-medium ${priceChangeColor}`}>
              {crypto?.price_change_percentage_24h}%
            </span>
          </div>
        </div>
      </div>

      <div className="text-right">
        <p className="text-base font-medium text-gray-900" style={{ color: theme === "dark" ? THEME_COLORS.dark.inverse_theme : "gray-900" }}>
          {(crypto?.balance ?? 0)?.toFixed(2)}
        </p>
        <p className="text-sm text-gray-600" style={{ color: theme === "dark" ? THEME_COLORS.dark.inverse_theme : "gray-600" }}>
          ${((crypto?.balance ?? 0) * (crypto?.current_price ?? 0))?.toFixed(2)}
        </p>
      </div>
    </div>
  );
}

export default CryptoListTileCard;
